import * as constants from './constants';

export const getItem = (payload) => ({ type: constants.GET_ITEM, payload });
export const getItemSuccess = (payload) => ({ type: constants.GET_ITEM_SUCCESS, payload });
export const getItemError = (payload) => ({ type: constants.GET_ITEM_ERROR, payload });

export const resetItem = () => ({ type: constants.RESET_ITEM });

export const deleteItems = (payload) => ({ type: constants.DELETE_ITEMS, payload });
export const deleteItemsSuccess = (payload) => ({ type: constants.DELETE_ITEMS_SUCCESS, payload });
export const deleteItemsError = (payload) => ({ type: constants.DELETE_ITEMS_ERROR, payload });

export const batchUpdateItem = (payload) => ({ type: constants.ITEM_BATCH_UPDATE, payload });
export const batchUpdateItemSuccess = () => ({ type: constants.ITEM_BATCH_UPDATE_SUCCESS });
// eslint-disable-next-line max-len
export const batchUpdateItemError = (payload) => ({ type: constants.ITEM_BATCH_UPDATE_ERROR, payload });

export const updateItem = (payload) => ({ type: constants.ITEM_UPDATE, payload });
export const updateItemSuccess = () => ({ type: constants.ITEM_UPDATE_SUCCESS });
// eslint-disable-next-line max-len
export const updateItemError = (payload) => ({ type: constants.ITEM_UPDATE_ERROR, payload });

export const createItem = (payload) => ({ type: constants.ITEM_CREATE, payload });
export const createItemSuccess = () => ({ type: constants.ITEM_CREATE_SUCCESS });
export const createItemError = (payload) => ({ type: constants.ITEM_CREATE_ERROR, payload });

export const likeItem = (payload) => ({ type: constants.ITEM_LIKE, payload });
export const likeItemSuccess = (payload) => ({ type: constants.ITEM_LIKE_SUCCESS, payload });
export const likeItemError = (payload) => ({ type: constants.ITEM_LIKE_ERROR, payload });

export const setNextItemData = (payload) => ({ type: constants.SET_NEXT_ITEM_DATA, payload });
export const resetNextItemData = () => ({ type: constants.RESET_NEXT_ITEM_DATA });

export const setUpdatedItems = (payload) => ({
  type: constants.SET_UPDATED_ITEMS,
  payload,
});

export const resetUpdatedItems = () => ({
  type: constants.RESET_UPDATED_ITEMS,
});
